import { render, staticRenderFns } from "./products.create.component.vue?vue&type=template&id=75f3fc95&scoped=true&"
import script from "./products.create.component.vue?vue&type=script&lang=js&"
export * from "./products.create.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f3fc95",
  null
  
)

export default component.exports